/**
 * @file: types.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { ReportContentType, ReportShareMethod } from '@euler/model';
import { ReportShareTarget } from '@euler/model/enum/ReportShareTarget';
import { ReportTabKey } from '@euler/model/viewmodel';

/**
 * Map the share-flow `shareType` flag to a share target. The staff
 * share UI tags a share to the service agent with `shareType: 'sa'`;
 * every other share (incl. the customer action sheet and SMS) targets
 * the car owner.
 */
export const reportShareTargetFromShareType = (
  shareType: string | null | undefined,
): ReportShareTarget =>
  shareType === 'sa'
    ? ReportShareTarget.ServiceAgent
    : ReportShareTarget.Customer;

export type ShareReportArgs = {
  target: { type: 'task' | 'report'; id: string };
  orderNo: string;
  reportNo: string;
  licensePlateNo: string;
  shareToken?: string;
  shareType?: 'sa';
  tab?: ReportTabKey;
  flowId?: string;
  success?: () => any;
};

export type ShareEventArgs = {
  /** order_no property */
  orderNo: string;
  /** report_no property */
  reportNo: string;
  /** license_plate_no property */
  licensePlateNo: string;
  /** task_no property */
  taskNo?: string | null;
  /** tab property */
  tab?: string | null;
  /** share_type property */
  shareType?: string | null;
};

export type ReportSharingLog = {
  id: string;
  orderNo: string;
  reportType: ReportContentType;
  shareMethod: ReportShareMethod;
  eventArgs: ShareEventArgs;
};
